import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { showToast } from '../utils/helpers';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { getExclusions, deleteExclusion } from "../lib/apiClient";
import RedactionConfiguration from "../Components/Redactions/Configuration";
import store from "../stores";

const Exclusions = observer((props) => {
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [exclusion, setExclusion] = useState(null);
  const [exclusions, setExclusions] = useState([]);
  const [showConfiguration, setShowConfiguration] = useState(false);
  const [isSubmitting, ] = useState(false);

  useEffect(() => {
    listExclusions();
  // eslint-disable-next-line
  }, []);

  const handleDelete = async()  => {
        
    const params = {
      accountSid: props.store.SessionStore.accountSid,
      exclusionSid: exclusion.sid        
    }
    
    const response = await deleteExclusion(params);

    if(response.successful){
      
      // loop all redactions and pull out the one that is in the store...
      if(exclusions.length){
        setExclusions(exclusions.filter(item => item.sid !== exclusion.sid) );
      }
      // close the modal..
      setShowDeleteConfirmation(false);
      setExclusion(null);
      showToast("The exclusion has been deleted!");
    }
   
  };

  const listExclusions = async ()=>{
    const response = await getExclusions({accountSid: props.store.SessionStore.getAccountSid()});
    if(response?.data?.records){
      setExclusions(response.data.records);
    }
  }

  const handleConfirmDeleteClose = ()=>{
    setShowDeleteConfirmation(false); 
    setExclusion(null);
  }

  const confirmDelete = (exclusion)=>{
    setExclusion(exclusion);
    setShowDeleteConfirmation(true);
  }

  const displayBucket = (exclusion) => {
    if(exclusion.buckets.length && exclusion.buckets.length === 1 && exclusion.buckets[0] === '*'){
      return 'All';
    }else{
      const buckets = store.SessionStore.buckets.filter(item => exclusion.buckets.includes(item.sid));
      if(buckets){
        return buckets.length;
      }else{
        return 'Unknown';
      }
    }
  }
  const displayEnvironments = (exclusion) => {
    if(exclusion.environments.length && exclusion.environments.length === 1 && exclusion.environments[0] === '*'){
      return 'All';
    }else{
      const environments = store.SessionStore.environments.filter(item => exclusion.environments.includes(item.sid));
      if(environments){
        return environments.length;
      }else{
        return 'Unknown';
      }
    }
  }

  return (
    <>
      {!showConfiguration ? (<>

      {exclusions.length ? (
        <>
         <div className="row mt-3">
                <div className="col-md-12">
                    <div className="card mb-4">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">                    
                                <div className="table">
                                    <table className="table">
                                    <thead>
                                        <tr>
                                        <th>Criteria</th>
                                        <th className="text-center">Bucket</th>
                                        <th className="text-center">Environments</th>
                                        <th className="text-center">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="table-border-bottom-0">
                                    {exclusions.map((exclusion) => (                      
                                        <tr key={`detail_${exclusion.sid}`}>
                                        <td>{exclusion.criteria}</td>
                                        
                                        <td className="text-center">{displayBucket(exclusion)}</td>
                                        <td className="text-center">{displayEnvironments(exclusion)}</td>
                                        <td className="text-center">
                                            <div className="dropdown text-center">
                                            <button type="button" className="btn p-0 dropdown-toggle hide-arrow" data-bs-toggle="dropdown"><i className="ti ti-dots-vertical"></i></button>
                                            <div className="dropdown-menu">
                                                {/*<button className="dropdown-item btn-link" onClick={()=>handleEdit(exclusion)} ><i className="ti ti-pencil me-1 mb-1"></i>Edit</button>*/}
                                                <button className="dropdown-item btn-link" onClick={()=>confirmDelete(exclusion)} ><i className="ti ti-trash me-1 mb-1"></i>Delete</button>
                                            </div>
                                            </div>
                                        </td>
                                        </tr>    
                                        ))}          
                                    </tbody> 
                                    </table>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </>
        ) : (
            <>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card mb-4">
                            <div className="card-body">
                                <div className="text-center flex-column">
                                    <h3>No Exclusions Setup</h3>
                                    <p>If you have specific requests that don't need to be logged or sent to ApiTraffic, they can be excluded. To add an exclusion, search for requests in your traffic log and then use the "Add Exclusion" option.</p>
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )}

    </>) : (<>
      <div className="row">
                <div className="col-md-12">
                    <div className="card mb-4">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">   
        <RedactionConfiguration {...props}
                close={()=>{
                  setShowConfiguration(false);
                  setExclusion(null);
                }}
                exclusion={exclusion}
                onComplete={(newExclusion)=>{
                  
                  listExclusions();
                  
                  if(exclusion){
                    showToast("Exclusion updated and any online servers have been pushed the update!");
                  }else{
                    showToast("Exclusion created and any online servers have been pushed the update!");
                  }       
                  setExclusion(null);
                }}/>
                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                </>)}

        <Modal show={showDeleteConfirmation} onHide={handleConfirmDeleteClose} >
          <Modal.Header closeButton>
            <Modal.Title>Delete Exclusion</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to delete this exclusion?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleConfirmDeleteClose}>Cancel</Button>
            {!isSubmitting ? (
                <Button variant="danger"  onClick={handleDelete}>Delete Exclusion</Button>
            ) : (
                <Button variant="danger" > <span className="spinner-border me-1" role="status" aria-hidden="true"></span>Deleting...</Button>
            )}  
          </Modal.Footer>
          
      </Modal>



    </>
  );
});

export default Exclusions;
